document.addEventListener('DOMContentLoaded', () => {
  const headerRoot = document.querySelector('.mk-header-wrapper');
  if (!headerRoot) return;

  const OPEN_CLASS = 'is-open';
  const ACTIVE_CLASS = 'is-active';
  const BODY_LOCK_CLASS = 'mk-mobile-drawer-open';
  const TRANSITION_MS = 280;

  const bagCountEls = Array.from(document.querySelectorAll('[data-bag-count]'));
  const bagLinks = Array.from(document.querySelectorAll('.mk-header__bag-link'));

  function getMobileDrawers() {
    return Array.from(document.querySelectorAll('[data-mobile-drawer]'));
  }

  function getSearchPanels() {
    return Array.from(document.querySelectorAll('[data-search-panel]'));
  }

  function lockPage() {
    document.documentElement.classList.add(BODY_LOCK_CLASS);
    document.body.classList.add(BODY_LOCK_CLASS);
  }

  function unlockPageIfNoOpenDrawer() {
    const hasOpenDrawer = getMobileDrawers().some((drawer) =>
      drawer.classList.contains(OPEN_CLASS)
    );

    if (!hasOpenDrawer) {
      document.documentElement.classList.remove(BODY_LOCK_CLASS);
      document.body.classList.remove(BODY_LOCK_CLASS);
    }
  }

  function getTriggerForDrawer(drawer) {
    if (!drawer || !drawer.id) return null;
    return document.querySelector(`[data-mobile-trigger][aria-controls="${drawer.id}"]`);
  }

  function openDrawer(trigger, drawer) {
    if (!trigger || !drawer) return;

    drawer.hidden = false;

    requestAnimationFrame(() => {
      drawer.classList.add(OPEN_CLASS);
      trigger.classList.add(ACTIVE_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
      lockPage();
    });
  }

  function closeDrawer(drawer) {
    if (!drawer) return;

    const trigger = getTriggerForDrawer(drawer);

    drawer.classList.remove(OPEN_CLASS);

    if (trigger) {
      trigger.classList.remove(ACTIVE_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
    }

    window.setTimeout(() => {
      if (!drawer.classList.contains(OPEN_CLASS)) {
        drawer.hidden = true;
      }
      unlockPageIfNoOpenDrawer();
    }, TRANSITION_MS);
  }

  function closeAllDrawers() {
    getMobileDrawers().forEach((drawer) => closeDrawer(drawer));
  }

  function renderBagCount(count) {
    const safeCount = Number.isFinite(count) && count > 0 ? count : 0;

    bagCountEls.forEach((el) => {
      el.textContent = String(safeCount);
      el.classList.toggle('is-hidden', safeCount === 0);
      el.setAttribute('aria-hidden', safeCount === 0 ? 'true' : 'false');
    });

    bagLinks.forEach((link) => {
      link.setAttribute('aria-label', safeCount > 0 ? `Bag (${safeCount})` : 'Bag');
    });
  }

  async function syncBagCount() {
    if (!bagCountEls.length) return;

    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      if (!response.ok) return;

      const cart = await response.json();
      renderBagCount(Number(cart && cart.item_count) || 0);
    } catch (_error) {
      // fail silently to avoid affecting header UX
    }
  }

  document.addEventListener('click', (event) => {
    const searchTrigger = event.target.closest('[data-search-trigger]');
    if (searchTrigger) {
      getSearchPanels().forEach((panel) => {
        panel.toggleAttribute('hidden');
      });
    }

    const mobileTrigger = event.target.closest('[data-mobile-trigger]');
    if (mobileTrigger) {
      const drawerId = mobileTrigger.getAttribute('aria-controls');
      const drawer = drawerId ? document.getElementById(drawerId) : null;
      if (!drawer) return;

      const isExpanded = mobileTrigger.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        closeDrawer(drawer);
      } else {
        closeAllDrawers();
        openDrawer(mobileTrigger, drawer);
      }
      return;
    }

    const drawerCloseTarget = event.target.closest('[data-mobile-drawer-close]');
    if (drawerCloseTarget) {
      const drawer = drawerCloseTarget.closest('[data-mobile-drawer]');
      closeDrawer(drawer);
      return;
    }

    const submenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
    if (submenuToggle) {
      const item = submenuToggle.closest('.mk-mobile-drawer__item');
      const submenu = item ? item.querySelector('[data-mobile-submenu]') : null;
      if (!submenu) return;

      const isExpanded = submenuToggle.getAttribute('aria-expanded') === 'true';
      submenuToggle.setAttribute('aria-expanded', String(!isExpanded));
      submenu.hidden = isExpanded;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllDrawers();
    }
  });

  document.addEventListener('megaska:cart-updated', (event) => {
    const itemCount = Number(event.detail && event.detail.item_count);

    if (Number.isFinite(itemCount)) {
      renderBagCount(itemCount);
      return;
    }

    syncBagCount();
  });

  window.addEventListener('pageshow', syncBagCount);

  renderBagCount(
    Number(bagCountEls[0] && bagCountEls[0].textContent) || 0
  );
});